/* TheseFrames background — the studioflows.io landing shader, verbatim
 * (Floating Lines, violet on black). Synced from Studioflow static/bgfx.js.
 *
 * TheseFrames always runs "lines" (window.SF_BGFX can override to "waves").
 * The nav FX button turns the canvas on/off via window.sfFxToggle; that
 * preference persists in localStorage 'tf-fx'.
 */
(function () {
  if (window.__tfBgfx) return; window.__tfBgfx = true;
  var VALID = { lines: 1, waves: 1 };
  var which = window.SF_BGFX;
  if (!VALID[which]) which = "lines";

  var canvas = document.createElement("canvas");
  canvas.id = "bgfx-canvas";
  canvas.style.cssText =
    "position:fixed;inset:0;width:100%;height:100%;z-index:0;pointer-events:none;background:#000";
  function mount() {
    var fx = document.querySelector(".bg-fx");
    (fx && fx.parentNode ? fx.parentNode : document.body)
      .insertBefore(canvas, fx || document.body.firstChild);
    var on = true;
    try { on = localStorage.getItem("tf-fx") !== "off"; } catch (e) {}
    if (on) document.body.classList.add("bgfx-on");
  }
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", mount);
  else
    mount();

  // The ambience image behind the shader keeps its URL in data-src on the
  // landing (base.html) so it isn't downloaded while the shader covers it.
  function showSpin() {
    var im = document.querySelector(".bg-spin");
    if (im && !im.getAttribute("src") && im.getAttribute("data-src"))
      im.src = im.getAttribute("data-src");
  }

  // No MSAA: the shaders anti-alias their own lines, and a full-screen
  // multisampled canvas is the single most expensive thing on page load.
  var gl = canvas.getContext("webgl", { alpha: false, antialias: false, desynchronized: true,
                                        powerPreference: "high-performance", preserveDrawingBuffer: false });
  if (!gl) {
    // No WebGL: never mount, fall back to the still ambience image.
    document.removeEventListener("DOMContentLoaded", mount);
    if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
    document.body.classList.remove("bgfx-on");
    showSpin();
    return;
  }

  var VERT = "attribute vec2 p; void main(){ gl_Position = vec4(p,0.,1.); }";

  var LINES = [
    "precision highp float;",
    "uniform float uTime; uniform vec2 uResolution; uniform vec2 uMouse; uniform vec3 uTint;",
    "mat2 rot(float r){ return mat2(cos(r),sin(r),-sin(r),cos(r)); }",
    "float wave(vec2 uv, float offset, vec2 suv, vec2 muv){",
    "  float y = sin(uv.x + offset + uTime*0.1)*(sin(offset + uTime*0.2)*0.3);",
    "  vec2 d = suv - muv;",
    "  float influence = exp(-dot(d,d)*5.0);",
    "  y += (muv.y - suv.y)*influence*(-0.5);",
    "  float m = uv.y - y;",
    "  return 0.0175/max(abs(m)+0.01,1e-3)+0.01;",
    "}",
    "void main(){",
    "  vec2 uv = (2.0*gl_FragCoord.xy - uResolution)/uResolution.y;",
    "  uv.y *= -1.0;",
    "  vec2 muv = uMouse; muv.y *= -1.0;",
    "  uv += muv*0.2;",
    "  float s = 0.0;",
    "  for(int i=0;i<20;i++){",
    "    float fi = float(i);",
    "    float angle = -1.0*log(length(uv)+1.0);",
    "    vec2 ruv = uv*rot(angle);",
    "    s += wave(ruv + vec2(0.04*fi + 2.0, -0.7), 1.5+0.2*fi, uv, muv)*0.1;",
    "  }",
    "  for(int i=0;i<15;i++){",
    "    float fi = float(i);",
    "    float angle = 0.2*log(length(uv)+1.0);",
    "    vec2 ruv = uv*rot(angle);",
    "    s += wave(ruv + vec2(0.06*fi + 5.0, 0.0), 2.0+0.15*fi, uv, muv)*0.3;",
    "  }",
    "  for(int i=0;i<10;i++){",
    "    float fi = float(i);",
    "    float angle = -0.4*log(length(uv)+1.0);",
    "    vec2 ruv = uv*rot(angle); ruv.x *= -1.0;",
    "    s += wave(ruv + vec2(0.08*fi + 10.0, 0.5), 1.0+0.2*fi, uv, muv)*0.05;",
    "  }",
    "  s = max(s - 0.18, 0.0);",
    "  s = 1.0 - exp(-s*1.1);",
    "  vec3 col = uTint * s;",
    "  col += mix(uTint, vec3(1.0), 0.55) * pow(s, 4.0) * 0.28;",
    "  gl_FragColor = vec4(col,1.0);",
    "}"
  ].join("\n");

  var WAVES = [
    "precision highp float;",
    "uniform float uTime; uniform vec2 uResolution; uniform vec2 uMouse; uniform vec3 uTint;",
    "#define C1 (uTint * 0.9)",
    "#define C2 vec3(1.0,1.0,1.0)",
    "#define C3 uTint",
    "#define HALF_PI 1.5707963",
    "float hashF(float n){ return fract(sin(n*127.1)*43758.5453123); }",
    "float smoothNoise(float x){ float i=floor(x); float f=fract(x); float u=f*f*(3.0-2.0*f); return mix(hashF(i),hashF(i+1.0),u); }",
    "float displaceA(float c,float t){ return sin(c*2.123)*0.2+sin(c*3.234+t*4.345)*0.1+sin(c*0.589+t*0.934)*0.5; }",
    "float displaceB(float c,float t){ return sin(c*1.345)*0.3+sin(c*2.734+t*3.345)*0.2+sin(c*0.189+t*0.934)*0.3; }",
    "vec2 rot2(vec2 p,float a){ float c=cos(a),s=sin(a); return vec2(p.x*c-p.y*s,p.x*s+p.y*c); }",
    "void main(){",
    "  vec2 coords = gl_FragCoord.xy/uResolution.xy;",
    "  coords = coords*2.0-1.0;",
    "  coords = rot2(coords,-0.7854);",
    "  float halfT = uTime*0.3*0.5, fullT = uTime*0.3;",
    "  vec2 mPos = rot2(uMouse,-0.7854);",
    "  float mDist = length(coords-mPos);",
    "  float mouseWarp = 2.0*exp(-mDist*mDist*4.0);",
    "  float wAx = coords.x + displaceA(coords.y,halfT) + mouseWarp;",
    "  float wAy = coords.y - displaceA(coords.x*cos(fullT)*1.235,halfT);",
    "  float wBx = coords.x + displaceB(coords.y,halfT) + mouseWarp;",
    "  float wBy = coords.y - displaceB(coords.x*sin(fullT)*1.235,halfT);",
    "  vec2 fA = vec2(wAx,wAy), fB = vec2(wBx,wBy);",
    "  vec2 blended = mix(fA,fB,mix(fA,fB,0.5));",
    "  float fadeTop = smoothstep(0.0,0.4,blended.y);",
    "  float fadeBottom = smoothstep(0.0,-0.4,blended.y);",
    "  float vMask = 1.0-max(fadeTop,fadeBottom);",
    "  float tileCount = mix(36.0,32.0,vMask);",
    "  float scaledY = blended.y*tileCount;",
    "  float nY = smoothNoise(abs(scaledY));",
    "  float ridge = pow(step(abs(nY-blended.x)*2.0,HALF_PI)*cos(2.0*(nY-blended.x)),5.0);",
    "  float lines = 0.0;",
    "  for(float i=1.0;i<3.0;i+=1.0){ lines += pow(max(fract(scaledY),fract(-scaledY)),i*2.0); }",
    "  float pattern = vMask*lines;",
    "  float cT = fullT;",
    "  float r = (pattern+lines*ridge)*(cos(blended.y+cT*0.234)*0.5+1.0);",
    "  float g = (pattern+vMask*ridge)*(sin(blended.x+cT*1.745)*0.5+1.0);",
    "  float b = (pattern+lines*ridge)*(cos(blended.x+cT*0.534)*0.5+1.0);",
    "  vec3 col = (r*C1+g*C2+b*C3)*0.2;",
    "  gl_FragColor = vec4(col,1.0);",
    "}"
  ].join("\n");

  var SOURCES = { lines: LINES, waves: WAVES };

  function compile(type, src) {
    var s = gl.createShader(type);
    gl.shaderSource(s, src);
    gl.compileShader(s);
    if (!gl.getShaderParameter(s, gl.COMPILE_STATUS))
      console.error(gl.getShaderInfoLog(s));
    return s;
  }

  var vs = compile(gl.VERTEX_SHADER, VERT);
  var buf = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, buf);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);

  var programs = {}, uniforms = {};
  function use(name) {
    var p = programs[name];
    if (!p) {
      p = gl.createProgram();
      gl.attachShader(p, vs);
      gl.attachShader(p, compile(gl.FRAGMENT_SHADER, SOURCES[name]));
      gl.linkProgram(p);
      programs[name] = p;
    }
    gl.useProgram(p);
    uniforms = {
      uTime: gl.getUniformLocation(p, "uTime"),
      uResolution: gl.getUniformLocation(p, "uResolution"),
      uMouse: gl.getUniformLocation(p, "uMouse"),
      uTint: gl.getUniformLocation(p, "uTint")
    };
    var loc = gl.getAttribLocation(p, "p");
    gl.enableVertexAttribArray(loc);
    gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
  }

  // Live switch for the nav toggle: compiles on first use, instant after.
  window.sfBgSet = function (name) {
    if (!VALID[name]) return;
    which = name;
    try { localStorage.setItem("tf-bg", name); } catch (e) {}
    use(name);
  };
  window.sfBgCurrent = function () { return which; };

  var mouse = [0, 0], target = [0, 0];
  window.addEventListener("mousemove", function (e) {
    target = [(e.clientX / innerWidth) * 2 - 1, -((e.clientY / innerHeight) * 2 - 1)];
  });

  function resize() {
    // Phones get a smaller pixel budget — these shaders are per-pixel hot.
    // 1.5x on Retina is indistinguishable for soft procedural lines and is
    // ~45% fewer pixels than 2x — each page load re-creates this canvas, so
    // the budget shows up directly as navigation lag.
    var coarse = window.matchMedia && matchMedia("(pointer: coarse)").matches;
    var dpr = Math.min(window.devicePixelRatio || 1, coarse ? 1.25 : 1.5);
    canvas.width = innerWidth * dpr;
    canvas.height = innerHeight * dpr;
    gl.viewport(0, 0, canvas.width, canvas.height);
    // Changing the size wipes the canvas: repaint at once instead of
    // showing black until the next animation frame.
    if (uniforms.uTime) draw();
  }
  window.addEventListener("resize", resize);
  resize();

  // Colour: the landing is violet; CRM themes pass window.SF_BGFX_TINT
  // ([r,g,b] 0..1) — e.g. the Silver theme runs the same lines in steel.
  var tint = [0.545, 0.361, 0.965];
  function readTint() {
    var t = window.SF_BGFX_TINT;
    if (t && t.length === 3) tint = [+t[0], +t[1], +t[2]];
  }
  readTint();
  window.sfBgTint = function (rgb) { window.SF_BGFX_TINT = rgb; readTint(); };

  // Speed multiplier: the landing runs at 1; the CRM wallpaper themes set
  // window.SF_BGFX_SPEED (e.g. 0.45) so the motion reads as ambience, not FX.
  var speed = (typeof window.SF_BGFX_SPEED === "number" && window.SF_BGFX_SPEED > 0)
    ? window.SF_BGFX_SPEED : 1;
  var reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduce) speed = 0;

  // Ambience (CRM wallpapers run at speed < 1) draws at ~30fps; nobody can
  // tell on a slow drift, and it halves the GPU time the UI competes with.
  var fxOn = true;
  try { fxOn = localStorage.getItem("tf-fx") !== "off"; } catch (e) {}
  window.sfFxToggle = function (on) {
    fxOn = !!on;
    canvas.style.display = fxOn ? "" : "none";
    document.body.classList.toggle("bgfx-on", fxOn);
    try { localStorage.setItem("tf-fx", fxOn ? "on" : "off"); } catch (e) {}
  };
  if (!fxOn) { canvas.style.display = "none"; document.body.classList.remove("bgfx-on"); }

  var minGap = speed < 1 ? 30 : 0, last = 0;
  var start = performance.now(), raf = 0, stopped = false;
  function draw() {
    mouse[0] += (target[0] - mouse[0]) * 0.05;
    mouse[1] += (target[1] - mouse[1]) * 0.05;
    gl.uniform1f(uniforms.uTime, ((performance.now() - start) / 1000) * speed);
    gl.uniform2f(uniforms.uResolution, canvas.width, canvas.height);
    gl.uniform2f(uniforms.uMouse, mouse[0], mouse[1]);
    gl.uniform3f(uniforms.uTint, tint[0], tint[1], tint[2]);
    gl.drawArrays(gl.TRIANGLES, 0, 3);
  }
  function frame(ts) {
    if (stopped) return;
    if (!document.hidden && fxOn && (!minGap || !ts || ts - last >= minGap)) {
      last = ts || 0;
      draw();
    }
    raf = requestAnimationFrame(frame);
  }
  // Teardown for the app's theme switcher: stop drawing, drop the canvas.
  window.sfBgStop = function () {
    stopped = true;
    if (raf) cancelAnimationFrame(raf);
    if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
    document.body.classList.remove("bgfx-on");
    showSpin();
    window.sfBgSet = null;
    window.sfBgCurrent = null;
  };
  use(which);
  // Paint the first frame synchronously, even in a background tab, so the
  // canvas is never black; frame() then keeps the loop going.
  if (fxOn) draw();
  raf = requestAnimationFrame(frame);
})();
